import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRightIcon } from '@heroicons/react/24/outline'

const Header: React.FC = () => {
  return (
    <header className="bg-surface-light border-b border-neutral-200">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 py-4 sm:py-6" aria-label="Global">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="text-lg sm:text-xl md:text-2xl font-bold text-brand-black font-['Arial'] whitespace-nowrap">
              llms.txt Generator
            </span>
          </Link>
        </div>
        <div className="flex flex-1 justify-end">
          <Link
            to="/generator"
            className="inline-flex items-center gap-x-1.5 sm:gap-x-2 rounded-md px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold shadow-sm btn-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-200"
          >
            <span className="hidden sm:inline">Create Your llms.txt</span>
            <span className="sm:hidden">Create</span>
            <ArrowRightIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" />
          </Link>
        </div>
      </nav>
    </header>
  )
}

export default Header 